export const OfficeInstallationListState = {
	url: '/installation',
	title: 'Office Installation List',
	template: '<office-installation-list-page></office-installation-list-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeInstallationListPageMod" */
			'@Containers/office-installation-page/office-installation-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
